export default {"src":"/_next/static/media/WhoWeAre_026A.64c90735.JPG","height":682,"width":1920};